{
  "name": "weld-manager-ui",
  "version": "2.6.0",
  "scripts": {
    "ng": "ng",
    "start": "node server.js",
    "build": "ng build",
    "build:prod": "ng build --configuration prod",
    "build:test": "ng build --configuration test",
    "test": "jest",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "pretty-quick": "pretty-quick --staged",
    "p:verify": "prettier --config ./.prettierrc --list-different \"src/{app,environments}/**/*{.ts,.html,.scss}\"",
    "p:fix": "prettier --config ./.prettierrc --write \"src/{app,environments}/**/*{.ts,.html,.scss}\"",
    "prepare": "husky"
  },
  "jest": {
    "preset": "jest-preset-angular",
    "setupFilesAfterEnv": [
      "<rootDir>/src/setup-jest.ts"
    ],
    "moduleNameMapper": {
      "^src/(.*)$": "<rootDir>/src/$1",
      "^@env/(.*)$": "<rootDir>/src/environments/$1"
    },
    "testPathIgnorePatterns": [
      "<rootDir>/nodemodules/",
      "<rootDir>/dist/"
    ],
    "globals": {
      "ts-jest": {
        "tsconfig": "<rootDir>/tsconfig.spec.json",
        "stringifyContentPathRegex": "\\.html$"
      }
    }
  },
  "private": true,
  "overrides": {
    "uuid": "^14.0.0",
    "@angular/build": {
      "vite": "7.3.7"
    },
    "@angular/cli": {
      "@modelcontextprotocol/sdk": "1.32.1"
    },
    "webpack-dev-middleware": "^7.4.5",
    "body-parser@1": "1.20.9",
    "body-parser@2": "2.4.0",
    "qs": "6.16.1"
  },
  "dependencies": {
    "@angular/animations": "20.3.34",
    "@angular/common": "20.3.34",
    "@angular/compiler": "20.3.34",
    "@angular/core": "20.3.34",
    "@angular/forms": "20.3.34",
    "@angular/platform-browser": "20.3.34",
    "@angular/platform-browser-dynamic": "20.3.34",
    "@angular/router": "20.3.34",
    "@cvx/cal-angular": "^20.0.0",
    "@microsoft/applicationinsights-angularplugin-js": "^15.3.2",
    "@microsoft/applicationinsights-clickanalytics-js": "^3.3.3",
    "@microsoft/applicationinsights-web": "^3.3.3",
    "@primeng/themes": "^20.4.0",
    "bootstrap": "^5.3.3",
    "exceljs": "^4.4.0",
    "express": "^4.21.2",
    "file-saver": "^2.0.5",
    "form-data": "^4.0.4",
    "generate-unique-id": "^2.0.3",
    "moment": "^2.30.1",
    "ngx-image-cropper": "^7.2.1",
    "pacote": "^21.0.4",
    "primeflex": "^3.3.1",
    "primeicons": "^7.0.0",
    "primeng": "^20.4.0",
    "process": "^0.11.10",
    "rxjs": "^7.8.1",
    "tar": "^7.5.7",
    "tslib": "^2.7.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.41",
    "@angular-eslint/builder": "20.0.0",
    "@angular-eslint/eslint-plugin": "20.0.0",
    "@angular-eslint/eslint-plugin-template": "20.0.0",
    "@angular-eslint/schematics": "20.0.0",
    "@angular-eslint/template-parser": "20.0.0",
    "@angular/build": "20.3.40",
    "@angular/cdk": "^20.0.0",
    "@angular/cli": "^20.0.0",
    "@angular/compiler-cli": "20.3.34",
    "@types/file-saver": "^2.0.7",
    "@types/jest": "^30.0.0",
    "@types/node": "^18.19.54",
    "@typescript-eslint/eslint-plugin": "^8.72.0",
    "@typescript-eslint/parser": "^8.72.0",
    "eslint": "^8.57.0",
    "eslint-config-prettier": "^9.1.0",
    "husky": "^9.1.6",
    "jest": "^30.2.0",
    "jest-environment-jsdom": "^30.2.0",
    "jest-preset-angular": "^16.1.1",
    "prettier": "^3.3.3",
    "pretty-quick": "^4.0.0",
    "typescript": "^5.8.2"
  }
}
